import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import CopyBox from '../components/bbcode/copybox';
//import VideoPlayer from '../components/video/video';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import '../components/fontawesome/fontawesome';

import PortalOverview from '../components/overview/overview';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

//import './css/stream.css';
//import './css/header.css';

class PortalServiceOverview extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: true,
				id: this.props.service,
				name: '',
				test: false
			},

			admins: [],
			members: [],
			

      //servicekey: '',
			overview: {},
			
      
		};
    
  };

  async componentDidMount() {
		//document.title = "";

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		
		/*let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/service/overview`, params);
		console.log(x.data);

		EventEmitter.emit('/client', y);
		
		consoleLog(x.data);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle(x.data.servicename);
			}
			this.setState({overview: x.data.overview, admins: x.data.admins, members: x.data.members});
		}
   */
		
	}

	componentWillUnmount() {
    
	}

  
	render() {
		const user = this.context;

		const online_admins = this.state.admins.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">10 mins</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		const online_members = this.state.members.map((e,i) => {
			return (
				<li key={i}>
					<Link to={`/profile/${e.username}`}>
						<div className="d-flex align-items-center">
							<div className="me-2 d-flex align-items-center">
								<span className={`avatar avatar-sm avatar-rounded ${'online'}`}>
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" className="rounded-circle" />
								</span>
								</div>
								<div className="flex-fill">
									<span>{e.title?e.title:e.username}</span>
								</div>
								<div>
									<span className="fs-10 fw-semibold text-muted">10 mins</span>
								</div>
						</div>
					</Link>
				</li>
			)
		});
		

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Overview</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
				
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<PortalOverview service={this.state.service.id} version="full" />
              </Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceOverview service={service} {...props} />
}
export default Stream;